import Head from "expo-router/head";

export function Manifest() {
  return (
    <Head>
      <link rel="manifest" href="/manifest.json" />
      <meta httpEquiv="cache-control" content="no-cache, no-store, must-revalidate" />
    </Head>
  );
}
